"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticFlexidao = void 0;
var SemanticFlexidao;
(function (SemanticFlexidao) {
    SemanticFlexidao.QUERY_GRIDS = "query.grids";
    SemanticFlexidao.QUERY_START_TIME = "query.startTime";
    SemanticFlexidao.QUERY_END_TIME = "query.endTime";
    SemanticFlexidao.CALCULATE_INTENSITIES = "Calculate Intensities";
})(SemanticFlexidao || (exports.SemanticFlexidao = SemanticFlexidao = {}));
//# sourceMappingURL=semantic.js.map